import { useEffect } from "react";
import AnalyticService from './services/AnalyticService';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUsPage";
import GamePage from "./pages/GamePage";
import VideoDetailPage from "./pages/VideoDetailPage";
import ChannelsPage from "./pages/ChannelsPage";
import VideosPage from "./pages/VideosPage";
import Header from "./widgets/Header/Header";
import Footer from "./widgets/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
    useEffect(() => {
        if (process.env.REACT_APP_MODE === "prod") {
            AnalyticService.createAndInsertYandexMetricaScript();
        }
    }, []);

    return (
            <Router
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <div className="app-wrapper">
                    <Header/>

                    <main className="app-main">
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/about-us" element={<AboutUsPage />}/>
                            <Route path="/channels" element={<ChannelsPage />}/>
                            <Route path="/videos" element={<VideosPage />}/>
                            <Route path="/game/:sessionId" element={<GamePage />}/>
                            <Route path="/video/:videoId" element={<VideoDetailPage />}/>
                        </Routes>
                    </main>
                    
                    <Footer />
                </div>
                <ScrollToTop />
            </Router>
    );
}

export default App
